export default __webpack_public_path__ + "static/media/gd.325a87ac.svg";